// Script para galeria customizada do tema DPropósito
document.addEventListener('DOMContentLoaded', function() {
  // Aguarda a galeria carregar
  setTimeout(initCustomGalleryVariantSwitcher, 1000);
});

function initCustomGalleryVariantSwitcher() {
  const variantSelectors = document.querySelectorAll('input[name^="options"], select[name^="options"]');
  
  if (variantSelectors.length === 0) {
    console.log('⚠️ Nenhum seletor de variante encontrado');
    return;
  }

  console.log('✅ Script de variantes carregado para galeria customizada');

  function switchToMatchingImage() {
    // Coleta os valores selecionados
    const selectedValues = [];
    
    variantSelectors.forEach(selector => {
      let value = '';
      
      if (selector.type === 'radio' && selector.checked) {
        value = selector.value.toLowerCase().trim();
      } else if (selector.tagName === 'SELECT') {
        value = selector.value.toLowerCase().trim();
      }
      
      if (value) {
        // Remove parênteses
        value = value.replace(/\s*\(.*?\)\s*/g, '').trim();
        
        // Se tiver barra, separa
        if (value.includes('/')) {
          value.split('/').forEach(part => {
            part = part.trim();
            if (part) selectedValues.push(part);
          });
        } else {
          selectedValues.push(value);
        }
      }
    });

    if (selectedValues.length === 0) return;

    console.log('🔍 Procurando imagem para:', selectedValues);

    // Procura nas miniaturas da galeria customizada
    const thumbnails = document.querySelectorAll('.custom-gallery__thumb');

    if (thumbnails.length === 0) {
      console.log('⚠️ Nenhuma miniatura encontrada');
      return;
    }

    let foundMatch = false;

    thumbnails.forEach((thumb) => {
      if (foundMatch) return;
      
      // Procura a imagem dentro da miniatura
      const img = thumb.querySelector('img');
      
      if (!img) return;
      
      const altText = (img.alt || '').toLowerCase().trim();
      
      // Verifica se o alt text contém TODAS as variantes selecionadas
      const matches = selectedValues.every(val => altText.includes(val));
      
      if (matches) {
        // Simula clique na miniatura (dispara o onclick="changeImage()")
        thumb.click();
        foundMatch = true;
        console.log('✅ Imagem ativada:', altText);
      }
    });

    if (!foundMatch) {
      console.log('⚠️ Nenhuma imagem correspondente encontrada');
      console.log('Imagens disponíveis:');
      thumbnails.forEach(thumb => {
        const img = thumb.querySelector('img');
        if (img) console.log(' -', img.alt);
      });
    }
  }

  // Escuta mudanças nas variantes
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function() {
      // Pequeno delay para garantir que o tema processou a mudança
      setTimeout(switchToMatchingImage, 200);
    });
  });

  // Executa uma vez no carregamento
  setTimeout(switchToMatchingImage, 500);
}